import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import PropTypes from 'prop-types';
import './styles.scss';

const getPieCharts = (pieData) => {
    if (pieData && pieData.length) {
        let innerRadius = 0;
        const pieWidth = 100 / pieData.length;
        const padding = 5;
        return (
            pieData &&
            pieData.map((pie, index) => {
                const { data } = pie;
                innerRadius =
                    index == 0 ? innerRadius : innerRadius + pieWidth + padding;

                let multipieProps = {};
                if (pieData.length > 1) {
                    // to fit pie chart inside each other
                    multipieProps.outerRadius = innerRadius + pieWidth;
                }

                return (
                    <Pie
                        key={index}
                        innerRadius={innerRadius} // calculate radius dynamically
                        {...multipieProps}
                        {...pie}
                    >
                        {data &&
                            data.map((entry, index) => {
                                return <Cell key={index} fill={entry.color} />;
                            })}
                    </Pie>
                );
            })
        );
    } else {
        return [];
    }
};

// eslint-disable-next-line no-unused-vars
function Chart({ width, height, pieData, showToolTip }) {
    const getToolTip = () => {
        return showToolTip ? <Tooltip /> : null;
    };

    return (
        <div className="pie-charts-wrapper">
            <ResponsiveContainer height={height} width={width}>
                <PieChart>
                    {getPieCharts(pieData)}
                    {getToolTip()}
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}

export const piePropTypes = {
    // value that determines the inner radius
    innerRadius: PropTypes.number,
    // value that determines the outer radius
    outerRadius: PropTypes.number,
    // array of data points
    data: PropTypes.arrayOf(PropTypes.object),
    // the label of the data points
    nameKey: PropTypes.string,
    // key used to plot data points e.g count
    dataKey: PropTypes.string,
};

getPieCharts.propTypes = piePropTypes;

getPieCharts.defaultProps = {
    data: [],
    dataKey: 'count',
    nameKey: 'tag',
    innerRadius: 100,
    outerRadius: 200,
};

Chart.propTypes = {
    // width of pie chart
    width: PropTypes.number,
    // height of pie chart
    height: PropTypes.number,
    // array of pie charts to plot
    pieData: PropTypes.arrayOf(PropTypes.shape(piePropTypes)),
    // determines if the tool tip is to be displayed
    showToolTip: PropTypes.bool,
};

Chart.defaultProps = {
    width: 400,
    height: 400,
    pieData: [
        {
            data: [],
            dataKey: 'count',
            nameKey: 'tag',
            innerRadius: 100,
            outerRadius: 200,
        },
    ],
    showToolTip: true,
};

export default Chart;
